<ng-container *notInPopulation="[populations.JuniorBluebirds]">
  <fgb-banner title="{{ 'marketplace.page.title' | translate }}" class="d-lg-flex d-none"></fgb-banner>
  <div class="d-block d-lg-none">
    <fgb-mobile-page-header
      pageTitle="rewards.page.title"
      [showFooter]="true"
      [showQr]="true"
      [backButtonLink]="'/'"
    ></fgb-mobile-page-header>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.JuniorBluebirds]">
  <fgb-banner [isImageBanner]="true" [imageBannerUrl]="'banners/kids-rewards-banner.jpg'" class="d-lg-flex d-none"></fgb-banner>
  <div class="d-block d-lg-none">
    <fgb-mobile-page-header
      pageTitle="rewards.page.title"
      [showFooter]="true"
      [showQr]="true"
      [backButtonLink]="'/'"
      [isImageBanner]="true"
      [imageBannerUrl]="'banners/kids-rewards-banner.jpg'"
    ></fgb-mobile-page-header>
  </div>
</ng-container>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-4" [ngClass]="isCorporate ? 'corporate-colors' : 'default-color'">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[0, 1, 2]"
    [defaultSort]="0"
  ></fgbcl-marketplace-list>
</div>
